"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendClient = void 0;
const AxiosHttpRequest_1 = require("./core/AxiosHttpRequest");
const AnnexLegalDocumentsService_1 = require("./services/AnnexLegalDocumentsService");
const CaptchaService_1 = require("./services/CaptchaService");
const CompaniesService_1 = require("./services/CompaniesService");
const CountriesService_1 = require("./services/CountriesService");
const FeatureAccessService_1 = require("./services/FeatureAccessService");
const GrantRevokeRightsService_1 = require("./services/GrantRevokeRightsService");
const InitService_1 = require("./services/InitService");
const KesCloudWorkspacesService_1 = require("./services/KesCloudWorkspacesService");
const LegalDocumentsService_1 = require("./services/LegalDocumentsService");
const LicensesService_1 = require("./services/LicensesService");
const MarketoService_1 = require("./services/MarketoService");
const MembersService_1 = require("./services/MembersService");
const PortalModeService_1 = require("./services/PortalModeService");
const SettingsService_1 = require("./services/SettingsService");
const TermsOfUsageService_1 = require("./services/TermsOfUsageService");
const UsersService_1 = require("./services/UsersService");
const WorkspaceRedirectService_1 = require("./services/WorkspaceRedirectService");
const WorkspacesService_1 = require("./services/WorkspacesService");
class BackendClient {
    constructor(config, HttpRequest = AxiosHttpRequest_1.AxiosHttpRequest) {
        var _a, _b, _c, _d;
        this.request = new HttpRequest({
            BASE: (_a = config === null || config === void 0 ? void 0 : config.BASE) !== null && _a !== void 0 ? _a : '',
            VERSION: (_b = config === null || config === void 0 ? void 0 : config.VERSION) !== null && _b !== void 0 ? _b : '1',
            WITH_CREDENTIALS: (_c = config === null || config === void 0 ? void 0 : config.WITH_CREDENTIALS) !== null && _c !== void 0 ? _c : false,
            CREDENTIALS: (_d = config === null || config === void 0 ? void 0 : config.CREDENTIALS) !== null && _d !== void 0 ? _d : 'include',
            TOKEN: config === null || config === void 0 ? void 0 : config.TOKEN,
            USERNAME: config === null || config === void 0 ? void 0 : config.USERNAME,
            PASSWORD: config === null || config === void 0 ? void 0 : config.PASSWORD,
            HEADERS: config === null || config === void 0 ? void 0 : config.HEADERS,
            ENCODE_PATH: config === null || config === void 0 ? void 0 : config.ENCODE_PATH,
            HTTPS_AGENT: config === null || config === void 0 ? void 0 : config.HTTPS_AGENT,
            FALLBACK_BASE_URL: config === null || config === void 0 ? void 0 : config.FALLBACK_BASE_URL,
            REQUEST_TIMEOUT: config === null || config === void 0 ? void 0 : config.REQUEST_TIMEOUT,
            LOGGER: config === null || config === void 0 ? void 0 : config.LOGGER,
        });
        this.annexLegalDocuments = new AnnexLegalDocumentsService_1.AnnexLegalDocumentsService(this.request);
        this.captcha = new CaptchaService_1.CaptchaService(this.request);
        this.companies = new CompaniesService_1.CompaniesService(this.request);
        this.countries = new CountriesService_1.CountriesService(this.request);
        this.featureAccess = new FeatureAccessService_1.FeatureAccessService(this.request);
        this.grantRevokeRights = new GrantRevokeRightsService_1.GrantRevokeRightsService(this.request);
        this.init = new InitService_1.InitService(this.request);
        this.kesCloudWorkspaces = new KesCloudWorkspacesService_1.KesCloudWorkspacesService(this.request);
        this.legalDocuments = new LegalDocumentsService_1.LegalDocumentsService(this.request);
        this.licenses = new LicensesService_1.LicensesService(this.request);
        this.marketo = new MarketoService_1.MarketoService(this.request);
        this.members = new MembersService_1.MembersService(this.request);
        this.portalMode = new PortalModeService_1.PortalModeService(this.request);
        this.settings = new SettingsService_1.SettingsService(this.request);
        this.termsOfUsage = new TermsOfUsageService_1.TermsOfUsageService(this.request);
        this.users = new UsersService_1.UsersService(this.request);
        this.workspaceRedirect = new WorkspaceRedirectService_1.WorkspaceRedirectService(this.request);
        this.workspaces = new WorkspacesService_1.WorkspacesService(this.request);
    }
}
exports.BackendClient = BackendClient;
